module.exports = __webpack_public_path__ + "assets/img/mouse.039cbed6.svg";